/* Generated by TinySVG. Do not edit directly. */
import type { TinyIconProps } from '../types.ts'

export function DonutIcon({
  size = 24,
  color = 'currentColor',
  strokeWidth,
  title,
  ...svgProps
}: TinyIconProps) {
  const resolvedStrokeWidth = strokeWidth ?? 1.75
  const scaledStrokeWidth = (percent: number) => {
    const numericStrokeWidth = typeof resolvedStrokeWidth === 'number' ? resolvedStrokeWidth : Number(resolvedStrokeWidth)
    return Number.isFinite(numericStrokeWidth) ? numericStrokeWidth * percent / 100 : resolvedStrokeWidth
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      strokeWidth={resolvedStrokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      data-icon="donut"
      data-variant="outline"
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
          <path d="M21.012 8.996A9.5 9.5 0 1 1 15.004 2.988" data-tinysvg-shape="arc" data-tinysvg-arc="12 12 9.5 9.5 341.565 288.435 0 center" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M15 3C13.844 4.541 15.062 6.722 16.979 6.547L17.5 6.5L17.453 7.021C17.278 8.938 19.459 10.156 21 9" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
          <circle cx={12} cy={12} r={2.915} stroke={color} fill="none" data-stroke-tone="primary" />
    </svg>
  )
}
